import React from "react";
import axios from "axios";
// import "./styles.scss";
import i18n from "../../../i18n";
import imagenLogin from "./../../../resources/fondo-login-xpdconnect.jpg";
import {
  Label,
  Container,
  Col,
  Form,
  Card,
  CardHeader,
  CardBody,
  Button,
  Row,
} from "reactstrap";
import { Services } from "../../../repositories/clients/Services";
import logoEuroPartners from "./../../../resources/ePoint_blanco_color.png";
import { withRouter } from "react-router-dom";
import { Input } from "semantic-ui-react";
import { withNamespaces } from "react-i18next";

import logo from "./../../../resources/logo-xpdconnect-blanco.svg";

const BackgroundHead = {
  backgroundImage: `url(${imagenLogin})`,
  backgroundSize: "cover",
  backgroundPosition: "bottom",
};
/*=============================================
=            Login Component                  =
=============================================*/
function ChangePassworsPolicy(props) {
  const [redirectlogin, setRedirectlogin] = React.useState({
    login: {
      newcontrasena: "",
      valid: false,
      confirmarcontrasena: "",
      check: false,
      email: "",
    },
  });
  let [Mostrar, setMostrar] = React.useState(false);
  let [MostrarNew, setMostrarNew] = React.useState(false);
  let [exito, setexito] = React.useState(false);
  let [TokenValido, setTokenValido] = React.useState(true);
  let [passValid, setPassValid] = React.useState(true);
  let [lengthPassword, setLengthPassword] = React.useState(false);
  let [upperCasePassword, setUpperCasePassword] = React.useState(false);
  let [specialCharPassword, setSpecialCharPassword] = React.useState(false);
  let [newPassword, setNewPassword] = React.useState("");
  let [confirmPassword, setConfirmPassword] = React.useState("");
  const getAutentication = React.useCallback(() => {
    axios
      .get(
        `${Services.ADMIN.path}admin/recovery?token=${props.match.params.token}`,
        {}
      )
      .then((response) => {
        redirectlogin.login.email = response.data.email;
        setRedirectlogin({ redirectlogin, ...redirectlogin });
        setTokenValido(true);
      })
      .catch((error) => {
        setTokenValido(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.token]);

  React.useEffect(() => {
    getAutentication();
  }, []);

  React.useEffect(() => {
    let validText = newPassword;
    let lengthPassword = false;
    let upperCasePassword = false;
    let specialCharPassword = false;

    if (validText.length > 7 && validText.length < 16) {
      lengthPassword = true;
    }
    if (/[A-Z]/.test(validText) && /[a-z]/.test(validText)) {
      upperCasePassword = true;
    }
    if (/["#$%&]/.test(validText)) {
      specialCharPassword = true;
    }

    setLengthPassword(lengthPassword);
    setUpperCasePassword(upperCasePassword);
    setSpecialCharPassword(specialCharPassword);

    if (newPassword === confirmPassword) {
      if (lengthPassword && upperCasePassword && specialCharPassword) {
        setPassValid(false);
        //document.getElementById("input_correo").className = "input100";
      } else {
        //document.getElementById("input_correo").className = "invalidInput";
        setPassValid(true);
      }
    } else {
      //document.getElementById("input_correo").className = "invalidInput";
      setPassValid(true);
    }
  }, [newPassword]); // <- Dependencia

  React.useEffect(() => {
    let validText = confirmPassword;
    let lengthPassword = false;
    let upperCasePassword = false;
    let specialCharPassword = false;

    if (validText.length > 7 && validText.length < 16) {
      lengthPassword = true;
    }
    if (/[A-Z]/.test(validText) && /[a-z]/.test(validText)) {
      upperCasePassword = true;
    }
    if (/["#$%&]/.test(validText)) {
      specialCharPassword = true;
    }
    setLengthPassword(lengthPassword);
    setUpperCasePassword(upperCasePassword);
    setSpecialCharPassword(specialCharPassword);

    if (newPassword === confirmPassword) {
      if (lengthPassword && upperCasePassword && specialCharPassword) {
        setPassValid(false);
        //document.getElementById("input_correo").className = "input100";
      } else {
        //document.getElementById("input_correo").className = "invalidInput";
        setPassValid(true);
      }
    } else {
      document.getElementById("input_correo").className = "invalidInput";
      setPassValid(true);
    }
  }, [confirmPassword]); // <- Dependencia

  function change(event) {
    if (event.target.name === "newcontrasena") {
      setNewPassword(event.target.value);
    }
    if (event.target.name === "confirmarcontrasena") {
      setConfirmPassword(event.target.value);
    }

    if (
      event.target.name === "confirmarcontrasena" ||
      event.target.name === "newcontrasena"
    ) {
      let value = event.target.value;
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    } else {
      let value = event.target.value;

      const emailRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/
      );
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    }
  }

  function handleLoginId() {
    let data = {
      email: redirectlogin.login.email,
      password: redirectlogin.login.newcontrasena,
    };

    axios
      .put(`${Services.ADMIN.path}admin/changePass`, data)
      .then((response) => {
        setexito(true);
      })
      .catch((error) => {});
  }
  React.useEffect(() => {
    let navLang = navigator.language || navigator.userLanguage;
    i18n.changeLanguage(navLang.split("-")[0] == "es" ? "MX" : "US");
  }, []);

  return (
    <>
      <div style={BackgroundHead}>
        <div className="login-page ">
          <Container>
            <div className="">
              {
                <>
                  <Col
                    sm={10}
                    md={11}
                    lg={8}
                    xl={6}
                    className="ml-auto mr-auto mt-auto"
                  >
                    <center>
                      <Col xs={10} md={10} lg={10} className="ml-auto mr-auto">
                        <img src={logo} alt="now-logo" />
                      </Col>
                    </center>
                    <Col className="ml-auto mr-auto">
                      <CardBody className="cardForms">
                        {/* Inputs */}
                        <Col
                          xs={11}
                          sm={11}
                          md={11}
                          lg={11}
                          xl={11}
                          className="mr-auto ml-auto"
                        >
                          <center>
                            <label
                              style={{
                                color: "#fff",
                                fontSize: "20px",
                                fontWeight: "Bold",
                                marginBottom: "3rem",
                              }}
                            >
                              {props.t("change_policies")}
                            </label>
                          </center>

                          <label style={{ color: "#fff", fontSize: "18px" }}>
                            {props.t("change_password_policies")}
                          </label>
                        </Col>

                        {/* Buttom */}
                        <div className="col-12 divcenter">
                          <div className="col-sm-12 col-md-12 col-lg-8 col-xl-8 divcenter">
                            <Button
                              id="se_cumple"
                              block
                              style={{
                                marginBottom: "1em",
                                marginTop: "3em",
                                maxWidth: "200px",
                              }}
                              color="primary"
                              //style={{ fontWeight: 'bold', background: '#FF0000' }}
                              // color='danger'
                              onClick={() =>
                                props.history.push(
                                  `/recoverpassword/${props.match.params.token}`
                                )
                              }
                            >
                              <strong>{props.t("update_password")}</strong>
                            </Button>
                          </div>
                        </div>
                      </CardBody>
                    </Col>
                  </Col>
                </>
              }
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}
// export default withRouter(ChangePassworsPolicy);
export default withNamespaces()(ChangePassworsPolicy);
